import { queryOptions } from "@tanstack/react-query";
import TicketService from "../ticket/ticket.service";



export const createAgentOptionsQuery = (customerId: number | undefined, ticketId?: number) => queryOptions<any>({
  queryKey: ['agents-by-customer', customerId, ticketId],
  queryFn: async () => {
    const ticketService = TicketService();
    if (!customerId) return new Promise((resolve) => resolve(null));
    return new Promise(async (resolve) => {
      await ticketService
        .getAgentsByCustomer({
          customerId: customerId,
          ticketId: ticketId,
        })
        .then((res) => {
          resolve(res.data);
        });
    });
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  enabled: !!customerId,
  refetchOnWindowFocus: false,
});

export const createWorkflowAgentByCustomerQuery = ({ customerId }: { customerId?: number }) => queryOptions<any>({
  queryKey: ['workflow-agents-by-customer', customerId],
  queryFn: async () => {
    const ticketService = TicketService();
    if (!customerId) return new Promise((resolve) => resolve(null));
    return new Promise(async (resolve) => {
      await ticketService
        .getWorkflowAgentsByCustomer({
          customerId: customerId,
        }).then((res) => {
          resolve(res.data);
        });
    });
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  enabled: !!customerId,
  refetchOnWindowFocus: false,
});
